'use client';

import React from 'react';

interface AppLogoProps {
  src?: string;
  text?: string;
  iconName?: string;
  size?: number;
  className?: string;
  onClick?: () => void;
  variant?: 'default' | 'light' | 'dark';
}

function AppLogo({
  className = '',
  onClick,
  variant = 'default',
}: AppLogoProps) {
  return (
    <div
      className={`flex items-center ${onClick ? 'cursor-pointer hover:opacity-85' : ''} ${className}`}
      onClick={onClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 220 52"
        width="180"
        height="44"
        aria-label="VS Cardoso Negócios Imobiliários"
        role="img"
      >
        {/* Gold accent bar left */}
        <rect x="0" y="8" width="2.5" height="36" fill="#C9A84C" rx="1" />

        {/* VS CARDOSO — primary brand name */}
        <text
          x="12"
          y="28"
          fontFamily="'Fraunces', Georgia, serif"
          fontSize="22"
          fontWeight="600"
          letterSpacing="0.06em"
          fill={variant === 'light' ? '#0A0F0D' : '#F0EDE8'}
        >
          VS CARDOSO
        </text>

        {/* Thin gold divider line */}
        <line x1="12" y1="33" x2="208" y2="33" stroke="#C9A84C" strokeWidth="0.6" opacity="0.6" />

        {/* NEGÓCIOS IMOBILIÁRIOS — tagline */}
        <text
          x="12"
          y="45"
          fontFamily="'DM Sans', Arial, sans-serif"
          fontSize="7.5"
          fontWeight="400"
          letterSpacing="0.22em"
          fill="#C9A84C"
          opacity="0.9"
        >
          NEGÓCIOS IMOBILIÁRIOS
        </text>
      </svg>
    </div>
  );
}

export default AppLogo;
